import React from 'react';
import styled from 'styled-components';
//
import { RichText } from 'components/prismic';
//
export default ({ description, descriptionLeft, hasMedia, mediaWidth }) => (
  <Wrap
    mediaWidth={mediaWidth}
    withMedia={hasMedia}
    descriptionLeft={descriptionLeft}
  >
    <RichText {...description} />
  </Wrap>
);
//
const Wrap = styled.div`
  bottom: 0;
  left: ${({ descriptionLeft }) => (descriptionLeft ? 0 : 'auto')};
  line-height: 1.2;
  overflow: scroll;
  position: absolute;
  right: ${({ descriptionLeft }) => (descriptionLeft ? 'auto' : 0)};
  top: 0;
  width: ${({ mediaWidth, withMedia }) =>
    withMedia ? `calc(${(1 / (mediaWidth + 1)) * 100}% - .7vw)` : '100%'};
  z-index: 20;
`;
